const not = predicate =>
    function negated(...args) {
        return !predicate(...args);
    };

export default not;
